<template>
  <div class="icu-support-wrapper">
    <v-tooltip
      :shown.sync="isTooltipShown"
      theme="support-tooltip"
    >
      <div class="icu-support" :class="{'active': isTooltipShown}" />
      <template #popper>
        <slot></slot>
      </template>
    </v-tooltip>
  </div>

</template>

<script>
export default {
  name: 'IcuSupport',
  data() {
    return {
      isTooltipShown: false
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/theme.scss";

.icu-support {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background-color: $active-green;
  transition: background-color .15s;
  box-shadow: 0 20px 25px rgba(0, 0, 0, 0.05);
  border-radius: 50%;

  &-wrapper {
    position: fixed;
    right: 50px;
    bottom: 20px;
    z-index: 1;

    @media (max-width: $tablet) {
      right: 20px;
    }

    @media (max-width: $mobile) {
      bottom: 10px;
      right: 10px;
    }
  }

  &.active {
    background-color: $white;

    &::after {
      background-color: $active-green;
    }
  }

  &::after {
    content: "";
    width: 34px;
    height: 34px;
    mask: url("~@/assets/img/components/common/IcuSupport/support-icon.svg") no-repeat center;
    mask-size: 34px;
    transition: background-color .15s;
    background-color: $white;
  }
}
</style>
